import React from "react"
import Template from "../../components/Template"
import img1 from "../../images/indicators/indicators.jpg"
import Translations from "../../../components/Translations"

function EMACross() {
    const Content = () => {
        return (
            <div className={`flex flex-col gap-5`}>
                <img src={img1} alt='/' className={`border border-gray-700 mt-5 mb-5 w-[20%]`}></img>
                <p className={`text-lg`}><Translations category={"docsEMAcross"} id={1}/></p>
                <p className={`text-lg`}><Translations category={"docsEMAcross"} id={2}/></p>
                <p className={`text-lg`}><Translations category={"docsEMAcross"} id={3}/></p>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={26}/>,
        previousLink: '/docs/exponential-moving-average',
        previousTitle: <Translations category={"docs"} id={25}/>,
        nextLink: '/docs/historical-min-max',
        nextTitle: <Translations category={"docs"} id={27}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default EMACross